import defaultIpInfo from "./config/defaultIpInfo";

export const deviceType = "pc";
export const appVersion = "2.0";
export const isLocalDev = ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);
export const GLOBAL_COOKIE_DOMAIN: string | undefined = isLocalDev
  ? undefined
  : window.location.hostname.includes("staging-clip")
    ? "staging-clip.kalowave.com"
    : "clip.kalowave.com";
export const API_URL = isLocalDev ? "" : window.location.origin;

// export const CDN_STATIC_URL = "https://d3o1auz8ao5c3e.cloudfront.net"; // 前端静态资源地址
export const CDN_STATIC_URL =
  window.KALO_DATA?.reqCountry === "China"
    ? "https://global.kalocdn.com/global"
    : "https://d4ewq8axz3ayo.cloudfront.net/global"; // 前端静态资源地址 => https://s3.ap-southeast-1.amazonaws.com/kalowave.app.data-service-frontend/dist

export const CDN_IMG_URL = window.KALO_DATA.imgCdn ? "https://" + window.KALO_DATA.imgCdn : "https://img.kalocdn.com";

export const CDN_UPLOAD_URL =
  window.KALO_DATA?.reqCountry === "China" ? "https://upload.kalowave.cn" : "https://d149xzut2sq6e3.cloudfront.net";

// 视频上传走 CDN 边缘加速域名（与 API_URL 同 path，不同 host）
export const VIDEO_UPLOAD_CDN_URL =
  import.meta.env.MODE === "production" ? "https://dapi.kaloclip.com" : "https://staging-dapi.kaloclip.com";
export const CDN_ASSETS_URL =
  window.KALO_DATA?.reqCountry === "China" ? "https://cdn.kalocdn.com" : "https://d4ewq8axz3ayo.cloudfront.net";

export const DEFAULT_COUTNRY = "US";
export const DEFAULT_CURRENCY = "USD";
export const Delimiter = "~";
export const FULL_SERVICE = 1; // 全托管

export const LOCALSTORAGE_KEY = {
  CURRENCY: "currency",
  LANGUAGE: "language",
  REGION: "region", // 全局使用
  OVERVIEW_COUNTRY: "overview_country", // 只是用作是否勾选，不使用其值
  TRACK_CODE: "tc",
  GUILD_CLOSE_TIP: "guild_close_tip",
  PAGELIST_REVENUE_TIP: "pagelist_revenue_tip",
  USERNAME: "userName",
  FLOAT_CONTACT: "float_contact",
  LOGIN_TYPE: "login_type", // 登录类型
  ANNOUNCEMENT: "announcement-v2", // 通告
  LOGIN_METHOD: "login_method",
  COUNTDOWN_FORGET_PASSWORD_EMAIL: "countdown_forget_password_email",
  SETTING_MOVE_TIP: "setting_move_tip", // 是否显示老用户移动国家和地区的提示
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  SOCIAL_PUBLISHER_CREDITS_BANNER: "social_publisher_credits_banner",
};
export const SESSIONSTORAGE_KEY = {
  SESSIONID: "sessionid",
};

export const DEFAULT_REGION = (() => {
  const phoneRegion = localStorage.getItem("phoneRegion") || defaultIpInfo.region;
  localStorage.setItem("phoneRegion", phoneRegion);
  return phoneRegion;
})();

export const DEFAULT_CODE = () => {
  const phonePrefix = localStorage.getItem("phonePrefix") || defaultIpInfo.phoneCode;
  localStorage.setItem("phonePrefix", phonePrefix);
  return phonePrefix;
};

export const DEFAULT_LANGUAGE = "en-US";

export const DEFAULT_FONT_FAMILY = "Roboto";

export const MEMBER_MODULE: any = {
  ACCOUNT_SUBCOUNT: "ACCOUNT.SUBCOUNT",
  OVERVIEW_POTENTIAL_LIST: "OVERVIEW.POTENTIAL_LIST",
  OVERVIEW_DETAIL: "OVERVIEW.DETAIL",
  OVERVIEW_LEVEL_THIRD: "OVERVIEW.LEVEL_THIRD",
  OVERVIEW_DATA_RANGE: "OVERVIEW.DATA_RANGE",
  VIDEO_LIST: "VIDEO.LIST",
  VIDEO_DETAIL: "VIDEO.DETAIL",
  LIVESTREAM_LIST: "LIVESTREAM.LIST",
  LIVESTREAM_DETAIL: "LIVESTREAM.DETAIL",
  PRODUCT_LIST: "PRODUCT.LIST",
  PRODUCT_DETAIL: "PRODUCT.DETAIL",
  CREATOR_LIST: "CREATOR.LIST",
  CREATOR_DETAIL: "CREATOR.DETAIL",
  CREATOR_MCN_SIGN: "CREATOR.MCN_SIGN",
  CREATOR_CONTACT: "CREATOR.CONTACT",
  CREATOR_COLLABORATED_SHOP: "CREATOR.COLLABORATED_SHOP",
  FORYOU_TABLELIST: "FORYOU.TABLELIST",
  FORYOU_COLLABORATED_SHOP: "FORYOU.COLLABORATED_SHOP",
  FORYOU_HOT: "FORYOU.HOT",
  FORYOU_FOCUS_COUNT: "FORYOU.FOCUSCOUNT",
  SHOP_LIST: "SHOP.LIST",
  SHOP_DETAIL: "SHOP.DETAIL",
  DOWNLOAD_VIDEO: "DOWNLOAD.VIDEO",
  FILTER_CUSTOM_RANGE: "FILTER.CUSTOM_RANGE",
  LIST_DATE_RANGE: "LIST.DATE_RANGE",
  DETAIL_DATE_RANGE: "DETAIL.DATE_RANGE",
  LIST_DATE_SPACING: "LIST.DATE_SPACING",
  DETAIL_DATE_SPACING: "DETAIL.DATE_SPACING",
  LIVESTREAM_FULL_RECORD: "LIVESTREAM.FULL_RECORD",
  LIST_CATE_CASCADER_LIST: "LIST.CATE_CASCADER_LIST",
  FILTER_CUSTOM_TIMES: "FILTER.CUSTOM_TIMES",
  DETAIL_ACCESS_TIMES: "DETAIL.ACCESS_TIMES",
  DATA_EXPORT: "DATA.EXPORT",
  AD_ANALYSIS: "AD.ANALYSIS",
  AD_CREATOR_DEBUT: "AD.CREATOR_DEBUT",
  CUSTOMIZED_DATA_EXPORT: "CUSTOMIZED.DATA.EXPORT",
  DATA_EXPORT_NUM: "DATA.EXPORT.NUM",
  AI_CREDITS: "AI.CREDITS",
  AISTUDIO_SCRIPT_EXPORT: "AI.CREDITS",
};

export const MEMBER_EXPIRED_DAY = 10;

export const timeMap: { [key in string]: { min: string; sec: string } } = {
  "zh-CN": {
    min: "分钟",
    sec: "秒",
  },
  "en-US": {
    min: "min",
    sec: "sec",
  },
  "id-ID": {
    min: "menit",
    sec: "detik",
  },
  "vi-VN": {
    min: "phút",
    sec: "giây",
  },
  "th-TH": {
    min: "นาที",
    sec: "วินาที",
  },
};

export const facebooks = [
  {
    country: "Indonesia",
    url: "https://www.facebook.com/profile.php?id=100086609318653",
    name: "@Kalodata wave",
  },
  {
    country: "Thailand",
    url: "https://www.facebook.com/profile.php?id=100086649337058",
    name: "@Kalo data",
  },
  {
    country: "Vietnam",
    url: "https://www.facebook.com/profile.php?id=100088514056209",
    name: "@Kalodata Vietnam",
  },
  {
    country: "Malaysia",
    url: "https://www.facebook.com/KalodataMalaysia",
    name: "@Kalodata Malaysia",
  },
  {
    country: "Philippines",
    url: "https://www.facebook.com/profile.php?id=100092695251790",
    name: "@Kalodata Philippines",
  },
];

// 展示广告
export const AD_DISPLAY = 1;

export const LinkData: any = {
  service: {
    "en-US": "https://docs.google.com/document/d/1pcH7-qCyFA0VBfjta7_Gi3x635RL-ne8KZiXVn4yyW0/edit?usp=sharing",
    "es-ES": "https://docs.google.com/document/d/1pcH7-qCyFA0VBfjta7_Gi3x635RL-ne8KZiXVn4yyW0/edit?usp=sharing",
    "ja-JP": "https://docs.google.com/document/d/1pcH7-qCyFA0VBfjta7_Gi3x635RL-ne8KZiXVn4yyW0/edit?usp=sharing",
    "pt-BR": "https://docs.google.com/document/d/1pcH7-qCyFA0VBfjta7_Gi3x635RL-ne8KZiXVn4yyW0/edit?usp=sharing",
    "zh-CN": "https://kalowave.feishu.cn/docx/BF0Hd4BrXoq3wwxbaeecW4tUn5e",
    "id-ID": "https://kalowave.feishu.cn/docx/K2CCdCjiood6Brxtzq9cnLyxn8b",
    "th-TH": "https://kalowave.feishu.cn/docx/TToedsoPWo3tLWxmO1QcXfrsnmd",
    "vi-VN": "https://kalowave.feishu.cn/docx/CO8wd6vx2o0MmWxksWFcuGbCnyf",
  },
  privacy: {
    "en-US": "https://docs.google.com/document/d/1Y0F3J5dokCsuX10x3NCL_z242r6kX_El776MAZ7ZGMk/edit?usp=sharing",
    "es-ES": "https://docs.google.com/document/d/1Y0F3J5dokCsuX10x3NCL_z242r6kX_El776MAZ7ZGMk/edit?usp=sharing",
    "ja-JP": "https://docs.google.com/document/d/1Y0F3J5dokCsuX10x3NCL_z242r6kX_El776MAZ7ZGMk/edit?usp=sharing",
    "pt-BR": "https://docs.google.com/document/d/1Y0F3J5dokCsuX10x3NCL_z242r6kX_El776MAZ7ZGMk/edit?usp=sharing",
    "zh-CN": "https://kalowave.feishu.cn/docx/Zs7vdhnrJoyxswxmBe3cnHqWnXe",
    "id-ID": "https://kalowave.feishu.cn/docx/EOMjd0fa2oAjdxxlRCeclHRznWc",
    "th-TH": "https://kalowave.feishu.cn/docx/MzZndJiaIoFabNxIQOVc3ZbznRH",
    "vi-VN": "https://kalowave.feishu.cn/docx/Ris9dx1ozoAHiDx68raczwuWnsu",
  },
};

export const CLIENT_KEY = "awmytdmj7dyr2w28"; // this value can be found in app's developer portal
export const CLIENT_KEY_STAGING = "sbawn5umj7c3y01vgc";
export const GOOGLE_CLIENT_ID_STAGING = "125749001541-hig0q6i4qnlfo52r7b35riqdht9crksr.apps.googleusercontent.com";
export const GOOGLE_CLIENT_ID = "125749001541-hig0q6i4qnlfo52r7b35riqdht9crksr.apps.googleusercontent.com";

/** Google Tag Manager 容器 ID */
export const GTM_ID = "GTM-TNVV6JKL";

export const LevelMap = {
  Basic: "Starter",
  Standard: "Professional",
  Premium: "Enterprise",
};

export const ALL_CURRENCY = ["CNY", "USD", "IDR", "MYR", "THB", "VND", "PHP", "GBP", "SGD", "MXN", "EUR", "BRL", "JPY"];

export const getLocalStorageCurrency = () => {
  const currency = localStorage.getItem(LOCALSTORAGE_KEY.CURRENCY) || "";
  if (ALL_CURRENCY.includes(currency)) {
    return currency;
  }
  return DEFAULT_CURRENCY;
};

export const FBQ_EVENTS = {
  PageViewPricing: "PageViewPricing",
};

export const fbqTrackCustom = (eventName: string) => {
  try {
    window.fbq && window.fbq("trackCustom", eventName);
  } catch (err) {}
};
